import i18n from "i18next";
import {reactI18nextModule} from "react-i18next";
import lngDetector from 'i18next-browser-languagedetector';
// import Backend from 'i18next-xhr-backend';

import { Languages as LanguagesFallback } from "config/LanguageList.jsx";

import numbro from 'numbro';
import moment from 'moment';
import 'moment/locale/hr';

import { API } from "services/api";


let trans_groups = ['pagecontent', 'menu', 'common', 'map', 'layers',
//,'links', 'biogeo' , 'ua', 'natura2000', 'rzlclu', 'rzgle', 'uastl', 'imp', 'impch', 'impclch', 'dlt', 'tcd', 'grass', 'waw', 'wawpi'
];

API.getLanguages()
.then(langs => {
    if (!langs) {
        console.warn('Loading Fallback languages!');
        langs = LanguagesFallback;
    }
    langs.forEach(function(lang){
        trans_groups.forEach(function(group){
            API.getTranslations(lang.code, group)
            .then(data => {
                if (data) {
                    i18n.addResourceBundle(lang.code, group, data);
                } else {
                    console.error('Cannot load translations for language: ' + lang.code + ", group: " + group);
                }
            });

        });

    });
});

i18n
    .use(lngDetector)
    .use(reactI18nextModule)
    .init({
        ns: trans_groups,
        defaultNS: 'common',
        // backend: {
        //     loadPath: 'http://localhost:5000/api/v1//mw/api/v1/trans/{{lng}}/{{ns}}'
        // },
        detection: {
            order: ['querystring'],
            lookupQuerystring: 'lng'
        },
        fallbackLng: 'hr',
        keySeparator: false, // we do not use keys in form messages.welcome
        interpolation: {
            escapeValue: false // react already safes from xss
        },
        useCookie: false
    });

i18n.on('languageChanged', function(lng) {
    moment.locale(lng);
    numbro.setLanguage(lng);
    });

export default i18n;